import * as geom from "js/core/utilities/geom";
import { AnimationSequenceType, FormatType } from "common/constants.js";
import { TextGroup } from "js/elements/base/TextGroup";
import { Pictograph } from "js/elements/elements/infographics/Pictograph";
import CompareValuesItem from "./CompareValuesItem";
import CompareValuesItemLabel from "./CompareValuesItemLabel";

export default class CompareVerticalPictographItem extends CompareValuesItem {
    _build() {
        this.pictograph = this.addElement("pictograph", () => Pictograph, {
            labelElement: CompareValuesItemLabel,
            valueFunction: () => this.percentageValue,
            showValue: this.parentElement.format != FormatType.NONE,
            valuePosition: this.parentElement.model.valuePosition
        });
        this.text = this.addElement("text", () => TextGroup, {
            autoHeight: true
        });
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        let textProps = children.setProps(this.text, new geom.Size(size.width, options.textHeight), options);
        let pictProps = children.setProps(this.pictograph, size.deflate({ bottom: options.textHeight }));
        pictProps.bounds = new geom.Rect(size.width / 2 - pictProps.size.width / 2, 0, pictProps.size);
        textProps.bounds = new geom.Rect(0, pictProps.size.height, textProps.size);

        return { size };
    }

    get buildAnimations() {
        return [...this.pictograph.buildAnimations, {
            type: AnimationSequenceType.FADE,
            target: this.text.DOMNode,
            delay: duration => duration - 400
        }];
    }
}
